<template>
	<div style="background-color: #f2f2f4;min-height: 100%;">
	  <Header title="重修选课列表" type="0" route="/student/cxCuarChoose"></Header>
	  <div>
		<div class="list-head">
			<span @click="xqChang()">{{xqName}}</span>
		</div>
	  <div class="teachingProcess">
		<NOdata
		  title="暂无数据~"
		  v-if="this.pageData && this.pageData.length == 0"
		></NOdata>
		<div class="content">
		  <div class="contentDiv" style="background-color: #fff"  v-for="(item, index) in filterPageData" :key="index" >
			<span class="xkspan" @click="showDetal(item)">详情</span>
			<p>{{ item.kcmc }}</p>
			<ul>
			  <li>授课老师：{{ item.teachername }}</li>
			  <li>上课班级：{{ item.ktmc }}</li>
			</ul>
			<div class="xkrsmsgdiv">
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">上课人数：{{item.xkrs}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;">排课人数：{{item.pkrs}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">开课院系：{{item.kkdw}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课校区：{{item.skxq}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课时间：{{item.sktime}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课地点：{{item.skaddr}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">学时：{{item.zxs}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;">学分：{{item.xf}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">性别要求：{{item.xbyq}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">分组名称：{{item.fzmc}}</div>
				</div>
			
			</div>
			<div style="background-color:#fff;padding-right: 6% ;padding-top:0">
			 <div  style="background-color: #7469f8;margin-left: 10px;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;color: #fff;padding: 0;text-align: center;float: right;" @click="goItem(item)">
				选择
             </div>
			</div>
		</div>
		  </div>
		 
	  </div>
	  </div>
	  <van-popup v-model="popshow" round position="bottom">
      <van-picker
        :title=title
        show-toolbar
        :columns="cloumList"
        @cancel="popshow = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index);
          }
        "
    />
</van-popup>

	<van-popup v-model="detalShow" class="popup">
	 <h2>{{this.curItem.kcmc}}</h2>
	  <p>上课老师：<span>{{this.curItem.teachername}}</span></p>
      <p>上课班级：<span>{{this.curItem.ktmc}}</span></p>
      <p>上课人数：<span>{{this.curItem.xkrs}}</span></p>
      <p>排课人数：<span>{{this.curItem.pkrs}}</span></p>
      <p>开课院系：<span>{{this.curItem.kkdw}}</span></p>
      <p>上课校区：<span>{{this.curItem.skxq}}</span></p>
      <p>上课时间：<span>{{this.curItem.sktime}}</span></p>
      <p>上课地点：<span>{{this.curItem.skaddr}}</span></p>
      <p>学时：<span>{{this.curItem.zxs}}</span></p>
      <p>学分：<span>{{this.curItem.xf}}</span></p>
	  <p>性别要求：<span>{{this.curItem.xbyq}}</span></p>
	  <p>分组名称：<span>{{this.curItem.fzmc}}</span></p>
      <button @click="detalShow=false">知道了</button>
    </van-popup>

	  <van-dialog
      v-model="show"
      title="确认选课"
      show-cancel-button
      show-confirm-button
      @cancel="cancelDialog"
      @confirm="dialogConfirm"
    >
      <div class="wpjs-detail-message-box">
        您是否确认选择该课程
      </div>
    </van-dialog>

	<van-dialog
      v-model="show_ts"
      title="提示"
      :show-cancel-button="show_canclebut"
      show-confirm-button
      @cancel="cancelDialog_ts"
      @confirm="dialogConfirm_ts"
    >
      <div class="wpjs-detail-message-box">
        {{xkts_tittle}}
      </div>
    </van-dialog>
	  
	</div>
  </template>
  
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		title: "",
		show: false,
		popshow:false,
		cloumList:[],
		cxxq:'',
		cxid:this.$route.query.cxid,
		kcid:this.$route.query.kcid,
		tzdid:'',
		conperType :'',
		messageTittle:'',
		xqName:'所有校区',
		xqId:'XXXXXXX',
		yxtzdids:'',
		detalShow:false,
		curItem:{},
		xkts_tittle:'',
		show_ts:false,
		show_canclebut:true,
		titlecode:'',
		needcfbs:'',
	  };
	},
	methods: {
	  goItem(item) {
		this.tzdid = item.jx0404id;
		this.show = true;

	  },
	  cancelDialog(){
		this.tzdid = "";
		this.show = false;
	  },
	  async initData(){
		const params = {
			kcid:this.kcid
		}
		const res = await Api.cxXkKc_queryKcList(params)
		if (res.code == '1') {
			this.pageData = res.data
		} 
		},
		async findXqData(){
		  const params = {
			zzdtype:"Campus"
		  }
		  const res = await Api.findDictionry(params);
		  if(res.code=='1'){	
			let xqList = res.data.Campus;
			for(let i=0;i<xqList.length;i++){
				let xqobj={};
				xqobj.text = xqList[i].xqmc;
				xqobj.value = xqList[i].xqid;
				this.cloumList.push(xqobj);
			}
		  }
		},
		dialogConfirm(){
			this.show = false;	
			this.saveXkResult();		
		},
		async saveXkResult(){
			const params = {
				cxid:this.cxid,
				tzdid:this.tzdid,
				yxtzdids:this.yxtzdids
		  }
		  const res = await Api.saveXkResult(params);
		  this.titlecode = res.code;
			this.xkts_tittle = res.Msg;
			if(res.code == '3'){
				this.yxtzdids = res.data.yxjx0404ids;
				this.needcfbs = res.data.toChooseCfbs;
				this.show_canclebut = true
			}else{
				this.show_canclebut = false
			}
			this.show_ts = true;
		},
		dialogConfirm_ts(){
			 if(this.titlecode=='1'||this.titlecode=='4'){
				this.$router.push({ 
				path: "/student/cxCuarChoose", 
				});
			}else if(this.titlecode=='3'){
				const params = {
                cfbs:this.needcfbs,
                kcid:this.kcid,
              };
              this.getCfkcList(params);
			}
			this.show_ts = false;
		},
		async getCfkcList(params){
        const res = await Api.doChaooseCur_cfbs(params);
        if(res.code=='1'){
           this.pageData = res.data
        }    
      },
	  
		xqChang(){
			this.popshow = true;
		},
		onConfirm(item,index){
			this.xqId = item.value;
			this.xqName = item.text;
			this.popshow = false;
		},
		showDetal(item){
			this.detalShow = true;
			this.curItem = item;
		}
	},
	created() {
		this.initData();
		this.findXqData();
	},
	computed:{
      filterPageData:function(){
        if(this.xqId == "XXXXXXX"){
			return this.pageData;
		}else{			
			  return this.pageData.filter(item=>{
				return item.xqid==this.xqId;
			  })
		}
      }
    }
  };
  </script>
  <style scoped lang="less" >
  .teachingProcess-head{
	padding: 3% 5% 10px;
	background-color: #fff;
	height: 30px;
	padding-right: 10px ;
  }
  .list-head {
	  height: auto;
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  background-color: #fff;
	  width: 100%;
	  border-top: 1px solid #f2f2f4;
	  margin: auto;
	  text-align: center;
	}
  .teachingProcess {
	padding: 3% 5% 0;
	background-color: #f2f2f4;
	height: 100%;
	.content {
		margin-top: 5px;
	  div {
		background: #f2f2f4;
		border-radius: 5px;
		padding: 3% 0 3% 6%;
		margin-bottom: 5%;
		position: relative;
  
		p {
		  height: 22px;
		  font-family: PingFangSC-SNaNpxibold;
		  font-size: 16px;
		  color: #333333;
		  letter-spacing: 0;
		  font-weight: 600;
		  margin-bottom: 2%;
		}
  
		ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  font-weight: 400;
		}
		span {
		  position: absolute;
		  top: 0px;
		  right: 0px;
		  display: block;
		  width: 40px;
		  height: 24px;
		  border-radius: 0 8px 0 8px ;
		  font-size: 14px;
		  color: #7469fB !important;
		  line-height: 20px;
		  padding-left: 3%;
		}

		.xkspan{
			background: #5241b226;
			color: #41B29C;
		}
	  }
	}
	
  }
  .more.van-popup.van-popup--bottom {
	border-radius: 0 !important ;
  }
  .more {
	padding: 5% 0 5% 0;
	box-sizing: border-box;
	overflow: hidden;
	.van-tabs__content--animated {
	  height: 75vh;
	  overflow: auto;
	}
	.van-tabs--line .van-tabs__wrap {
	  border-bottom: 1px solid #f4f4f4;
	  .van-tab--active {
		.van-tab__text--ellipsis {
		  color: #212f6e !important;
		}
	  }
	  .van-tab__text--ellipsis {
		height: 20px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #8f95b5;
		text-align: center;
		letter-spacing: 0;
	  }
	  .van-tabs__line {
		background-color: #7469f8 !important;
		width: 25px;
		height: 3px;
		border-radius: 1.5px;
	  }
	}
	& > p {
	  width: 64px;
	  font-weight: bolder;
	  font-family: PingFangSC-Medium;
	  font-size: 16px;
	  color: #000000;
	  letter-spacing: 0;
	  text-align: center;
	  padding-left: 7%;
	}
	ul {
	  overflow: auto;
	  height: 36vh;
	  .choose {
		background-color: #f2f2f4;
	  }
	  li {
		height: 40px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #212f6e;
		font-weight: bold;
		display: flex;
		align-items: center;
		padding-right: 5%;
		padding-left: 7%;
		justify-content: space-between;
	  }
	}
  }

  .contentDiv{
		background-color: #fff;
	}
	.xkrsmsgdiv{
		margin-right:6% ;
		height: 105px;
		font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  font-weight: 400;
	}
	.lrbutomdiv{
		background-color: #7469f8;
		height: 30px;width: 80px;
		line-height: 30px;
		border-radius: 16px;
		color: #fff;
		padding: 0;
		text-align: center;
		margin-left: calc(100%-80px);
		
	}

	/deep/.wpjs-detail-message-box {
  min-height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  height: auto;

  .red {
    color: red;
  }
}


.van-popup.van-popup--center{box-sizing: border-box;padding: 20px;}
.van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{
	color: @attendance-color-1;
	line-height: 30px;
	font-family: PingFangSC-SNaNpxibold;
	font-size: 16px;
	letter-spacing: 0;
	font-weight: 600;
}
  .van-popup.van-popup--center>p>span{
	font-family: PingFangSC-SNaNpxibold;
	font-size: 14px;
	letter-spacing: 0;
	font-weight: bold;
}
  .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 30px;}
  .van-popup--center{width: 90%;border-radius: 5px;}
  .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}
  </style>
  


// WEBPACK FOOTER //
// src/components/student/cxCuarChoose/cxCuarChooseList.vue